import { firestoreAction } from "vuexfire";
import { db } from "@/services/firebase.service";
import * as utils from "@/utils.js";
import isEmpty from "lodash/isEmpty";

import {
    SetInvestorImportedData,
    SetOtherChargeImportedData
} from "./EtudeFinanciereHelpers";

export default {
    addPlanFinancement({ commit }, programmeDinvestissementPlanDeFinancement) {
        commit("ADD_PLAN_FINNANCE", programmeDinvestissementPlanDeFinancement);
    },

    addchiffreAffaire({ commit }, chiffreAffaire) {
        commit("ADD_CHIFFRE_AFFAIRE", chiffreAffaire);
    },

    addCaDetails({ commit }, caDetails) {
        commit("ADD_CA_DETAILS", caDetails);
    },

    removeOffer({ commit }, id) {
        commit("REMOVE_OFFER", id);
    },
    removeAchat({ commit }, id) {
        commit("REMOVE_ACHAT", id);
    },

    addAchatsPrevisionnel({ commit }, achatsPrevisionnel) {
        commit("ADD_ACHATS_PREVISIONNEL", achatsPrevisionnel);
    },

    addTauxDachat({ commit }, taux) {
        commit("ADD_TAUX_ACHATS", taux);
    },

    addAchatsPrevisionnelTotal({ commit }, achatsPrevisionnel) {
        commit("ADD_ACHATS_PREVISIONNEL_TOTAL", achatsPrevisionnel);
    },

    addEvolutionToChiffre({ commit }, chiffre) {
        commit("ADD_EVOLUTION_TO_CHIFFRE", chiffre);
    },

    addAutresCharges({ commit }, autresCharges) {
        commit("ADD_AUTRES_CHARGES", autresCharges);
    },

    removeAutresCharges({ commit }, autresCharges) {
        commit("REMOVE_AUTRES_CHARGES", autresCharges);
    },

    addFonctions({ commit }, fonctions) {
        commit("ADD_FONCTIONS", fonctions);
    },

    removeFonctions({ commit }, fonctions) {
        commit("REMOVE_FONCTIONS", fonctions);
    },
    addChargesPrevisonnel({ commit }, chargePrevisionnel) {
        commit("ADD_CHARGES_PREVISONNEL", chargePrevisionnel);
    },

    removeChargesPrevisonnel({ commit }, chargePrevisionnel) {
        commit("REMOVE_CHARGES_PREVISONNEL", chargePrevisionnel);
    },

    putInvestment({ commit }, investorProgramme) {
        if (
            !Array.isArray(investorProgramme.creditBancaire) &&
            !isEmpty(investorProgramme.creditBancaire)
        ) {
            investorProgramme.creditBancaire = [
                investorProgramme.creditBancaire,
                {
                    montant: null,
                    duree: null,
                    taux: null
                }
            ];
        }
        commit("PUT_INVESTMENT", investorProgramme);
    },

    putCADetails({ commit, rootGetters }, caDetails) {
        let chiffreDetail;
        if (
            rootGetters["user/isSettable"]("Chiffres d’affaires Prévisionnels")
        ) {
            chiffreDetail = caDetails.details;
        } else {
            chiffreDetail = caDetails;
        }
        commit("PUT_CA_DETAILS", chiffreDetail);
    },

    putAchatsPrevisionnel({ commit, rootGetters }, achatsPrevisionnel) {
        if (!rootGetters["user/isSimplifiedVersion"]) {
            commit(
                "PUT_TAUX_EVOLUTION_ACHATS",
                achatsPrevisionnel.tauxEvolution
            );
            if (rootGetters["user/isSettable"]("Achats Prévisionnels")) {
                commit("PUT_ACHATS_PREVISIONNEL", achatsPrevisionnel.details);
            }
        } else {
            commit("PUT_ACHATS_PREVISIONNEL", achatsPrevisionnel);
        }
    },

    putAutresCharges({ commit }, autresCharges) {
        commit("PUT_AUTRES_CHARGES", autresCharges);
    },

    putFonctions({ commit }, fonctions) {
        commit("PUT_FONCTIONS", fonctions);
    },

    putChargesPrevisonnel({ commit }, chargePrevisionnel) {
        commit("PUT_CHARGES_PREVISONNEL", chargePrevisionnel);
    },

    putTauxEvolutionChiffre({ commit }, TauxEvolutionChiffre) {
        commit("PUT_TAUX_EVOLUTION_CHIFFRE", TauxEvolutionChiffre);
    },

    putTauxRealisationChiffre({ commit }, TauxRealisationChiffre) {
        commit("PUT_TAUX_REALISATION_CHIFFRE", TauxRealisationChiffre);
    },

    putTauxRealisationAchats({ commit }, tauxRealisationAchats) {
        commit("PUT_TAUX_REALISATION_ACHATS", tauxRealisationAchats);
    },

    putTauxEvolutionAchats({ commit }, tauxEvolutionAchats) {
        commit("PUT_TAUX_EVOLUTION_ACHATS", tauxEvolutionAchats);
    },

    saveEditedOtherCharge: firestoreAction(({ rootState, commit }) => {
        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .get()
            .then(snapshot => {
                const doc = snapshot.data();
                return doc;
            })
            .then(doc => {
                const oldData = doc.autres_charges;
                const currentData = SetOtherChargeImportedData(rootState);
                const savedData = doc.OtherChargeImportedData;

                let oldDataIndex;
                let currentDataIndex;
                oldData.autreCharge.forEach((old, index) => {
                    savedData.otherChargeResult.forEach(saved => {
                        if (old.name === saved.name) {
                            if (old.value >= saved.value) {
                                oldData.autreCharge[index].value =
                                    old.value - saved.value;
                            } else {
                                oldData.autreCharge[index].value = 0;
                            }
                        }
                    });
                });

                if (
                    utils.isExisted(
                        "Location et charges locatives",
                        currentData.otherChargeResult
                    )
                ) {
                    oldDataIndex = oldData.autreCharge.findIndex(
                        item => item.name === "Location et charges locatives"
                    );

                    currentDataIndex = currentData.otherChargeResult.findIndex(
                        item => item.name === "Location et charges locatives"
                    );

                    if (oldDataIndex !== -1) {
                        oldData.autreCharge[oldDataIndex].value +=
                            currentData.otherChargeResult[
                                currentDataIndex
                            ].value;
                    } else {
                        oldData.autreCharge.push({
                            name: "Location et charges locatives",
                            value:
                                currentData.otherChargeResult[currentDataIndex]
                                    .value
                        });
                    }
                } else {
                    oldDataIndex = oldData.autreCharge.findIndex(
                        item => item.name === "Location et charges locatives"
                    );
                    if (
                        oldDataIndex !== -1 &&
                        oldData.autreCharge[oldDataIndex].value <= 0
                    ) {
                        oldData.autreCharge.splice(oldDataIndex, 1);
                    }
                }

                if (
                    utils.isExisted(
                        "Redevances crédit de bail",
                        currentData.otherChargeResult
                    )
                ) {
                    oldDataIndex = oldData.autreCharge.findIndex(
                        item => item.name === "Redevances crédit de bail"
                    );

                    currentDataIndex = currentData.otherChargeResult.findIndex(
                        item => item.name === "Redevances crédit de bail"
                    );

                    if (oldDataIndex !== -1) {
                        oldData.autreCharge[oldDataIndex].value +=
                            currentData.otherChargeResult[
                                currentDataIndex
                            ].value;
                    } else {
                        oldData.autreCharge.push({
                            name: "Redevances crédit de bail",
                            value:
                                currentData.otherChargeResult[currentDataIndex]
                                    .value
                        });
                    }
                } else {
                    oldDataIndex = oldData.autreCharge.findIndex(
                        item => item.name === "Redevances crédit de bail"
                    );
                    if (
                        oldDataIndex !== -1 &&
                        oldData.autreCharge[oldDataIndex].value <= 0
                    ) {
                        oldData.autreCharge.splice(oldDataIndex, 1);
                    }
                }

                commit("PUT_AUTRES_CHARGES", oldData);

                const autres_charges = {
                    autreCharge: oldData.autreCharge,
                    tauxEvolution: oldData.tauxEvolution,
                    total: oldData.autreCharge.reduce((a, b) => {
                        if (b.value < 0 || b.value === null) return a;
                        return a + b.value;
                    }, 0)
                };

                db.collection("bpis")
                    .doc(`${rootState.user.bpiId}`)
                    .update({
                        autres_charges: autres_charges,
                        OtherChargeImportedData: currentData
                    });
            });
    }),

    saveEditedInvestorsProgrammetechtools: firestoreAction(
        ({ rootState, commit }) => {
            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .get()
                .then(snapshot => {
                    const doc = snapshot.data();
                    return doc;
                })
                .then(doc => {
                    const savedData = {
                        tangibleAssetsOptions:
                            doc.importedData.tangibleAssetsOptions,
                        intangibleAssetsOptions:
                            doc.importedData.intangibleAssetsOptions
                    };

                    const oldData = doc.investors_programme;

                    oldData.tangibleAssetsOptions.forEach((old, index) => {
                        savedData.tangibleAssetsOptions.forEach(saved => {
                            if (
                                old.name === "Matériel et outillage" &&
                                saved.name === "Matériel et outillage"
                            ) {
                                if (old.value > saved.value) {
                                    oldData.tangibleAssetsOptions[index].value =
                                        old.value - saved.value;
                                } else {
                                    oldData.tangibleAssetsOptions[
                                        index
                                    ].value = 0;
                                }
                            }
                        });
                    });

                    let oldDataIndex;
                    let currentDataIndex;
                    const currentData = SetInvestorImportedData(rootState);

                    if (
                        utils.isExisted(
                            "Matériel et outillage",
                            currentData.tangibleAssetsOptions
                        )
                    ) {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Matériel et outillage"
                        );

                        currentDataIndex = currentData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Matériel et outillage"
                        );

                        if (oldDataIndex !== -1) {
                            oldData.tangibleAssetsOptions[oldDataIndex].value +=
                                currentData.tangibleAssetsOptions[
                                    currentDataIndex
                                ].value;
                        } else {
                            oldData.tangibleAssetsOptions.push({
                                name: "Matériel et outillage",
                                value:
                                    currentData.tangibleAssetsOptions[
                                        currentDataIndex
                                    ].value
                            });
                        }
                    } else {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Matériel et outillage"
                        );
                        if (
                            oldDataIndex !== -1 &&
                            oldData.tangibleAssetsOptions[oldDataIndex].value <=
                                0
                        ) {
                            oldData.tangibleAssetsOptions.splice(
                                oldDataIndex,
                                1
                            );
                        }
                    }

                    commit("PUT_INVESTMENT", oldData);

                    db.collection("bpis")
                        .doc(`${rootState.user.bpiId}`)
                        .update({
                            investors_programme: oldData,
                            importedData: currentData
                        });
                });
        }
    ),

    saveEditedInvestorsProgrammetechtechHardware: firestoreAction(
        ({ rootState, commit }) => {
            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .get()
                .then(snapshot => {
                    const doc = snapshot.data();
                    return doc;
                })
                .then(doc => {
                    const savedData = {
                        tangibleAssetsOptions:
                            doc.importedData.tangibleAssetsOptions !== undefined
                                ? doc.importedData.tangibleAssetsOptions
                                : [],
                        intangibleAssetsOptions:
                            doc.importedData.intangibleAssetsOptions !==
                            undefined
                                ? doc.importedData.intangibleAssetsOptions
                                : []
                    };

                    const oldData = doc.investors_programme;

                    oldData.tangibleAssetsOptions.forEach((old, index) => {
                        savedData.tangibleAssetsOptions.forEach(saved => {
                            if (
                                old.name === "Matériel informatique" &&
                                saved.name === "Matériel informatique"
                            ) {
                                if (old.value > saved.value) {
                                    oldData.tangibleAssetsOptions[index].value =
                                        old.value - saved.value;
                                } else {
                                    oldData.tangibleAssetsOptions[
                                        index
                                    ].value = 0;
                                }
                            }
                        });
                    });

                    let oldDataIndex;
                    let currentDataIndex;
                    const currentData = SetInvestorImportedData(rootState);

                    if (
                        utils.isExisted(
                            "Matériel informatique",
                            currentData.tangibleAssetsOptions
                        )
                    ) {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Matériel informatique"
                        );

                        currentDataIndex = currentData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Matériel informatique"
                        );

                        if (oldDataIndex !== -1) {
                            oldData.tangibleAssetsOptions[oldDataIndex].value +=
                                currentData.tangibleAssetsOptions[
                                    currentDataIndex
                                ].value;
                        } else {
                            oldData.tangibleAssetsOptions.push({
                                name: "Matériel informatique",
                                value:
                                    currentData.tangibleAssetsOptions[
                                        currentDataIndex
                                    ].value
                            });
                        }
                    } else {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Matériel informatique"
                        );
                        if (
                            oldDataIndex !== -1 &&
                            oldData.tangibleAssetsOptions[oldDataIndex].value <=
                                0
                        ) {
                            oldData.tangibleAssetsOptions.splice(
                                oldDataIndex,
                                1
                            );
                        }
                    }

                    commit("PUT_INVESTMENT", oldData);

                    db.collection("bpis")
                        .doc(`${rootState.user.bpiId}`)
                        .update({
                            investors_programme: oldData,
                            importedData: currentData
                        });
                });
        }
    ),

    saveEditedInvestorsProgrammetechfurniture: firestoreAction(
        ({ rootState, commit }) => {
            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .get()
                .then(snapshot => {
                    const doc = snapshot.data();
                    return doc;
                })
                .then(doc => {
                    const savedData = {
                        tangibleAssetsOptions:
                            doc.importedData.tangibleAssetsOptions,
                        intangibleAssetsOptions:
                            doc.importedData.intangibleAssetsOptions
                    };

                    const oldData = doc.investors_programme;

                    oldData.tangibleAssetsOptions.forEach((old, index) => {
                        savedData.tangibleAssetsOptions.forEach(saved => {
                            if (
                                old.name === "Mobilier de bureau" &&
                                saved.name === "Mobilier de bureau"
                            ) {
                                if (old.value > saved.value) {
                                    oldData.tangibleAssetsOptions[index].value =
                                        old.value - saved.value;
                                } else {
                                    oldData.tangibleAssetsOptions[
                                        index
                                    ].value = 0;
                                }
                            }
                        });
                    });

                    let oldDataIndex;
                    let currentDataIndex;
                    const currentData = SetInvestorImportedData(rootState);

                    if (
                        utils.isExisted(
                            "Mobilier de bureau",
                            currentData.tangibleAssetsOptions
                        )
                    ) {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Mobilier de bureau"
                        );

                        currentDataIndex = currentData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Mobilier de bureau"
                        );

                        if (oldDataIndex !== -1) {
                            oldData.tangibleAssetsOptions[oldDataIndex].value +=
                                currentData.tangibleAssetsOptions[
                                    currentDataIndex
                                ].value;
                        } else {
                            oldData.tangibleAssetsOptions.push({
                                name: "Mobilier de bureau",
                                value:
                                    currentData.tangibleAssetsOptions[
                                        currentDataIndex
                                    ].value
                            });
                        }
                    } else {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Mobilier de bureau"
                        );
                        if (
                            oldDataIndex !== -1 &&
                            oldData.tangibleAssetsOptions[oldDataIndex].value <=
                                0
                        ) {
                            oldData.tangibleAssetsOptions.splice(
                                oldDataIndex,
                                1
                            );
                        }
                    }

                    commit("PUT_INVESTMENT", oldData);

                    db.collection("bpis")
                        .doc(`${rootState.user.bpiId}`)
                        .update({
                            investors_programme: oldData,
                            importedData: currentData
                        });
                });
        }
    ),

    saveEditedInvestorsProgrammetechtransportation: firestoreAction(
        ({ rootState, commit }) => {
            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .get()
                .then(snapshot => {
                    const doc = snapshot.data();
                    return doc;
                })
                .then(doc => {
                    const savedData = {
                        tangibleAssetsOptions:
                            doc.importedData.tangibleAssetsOptions,
                        intangibleAssetsOptions:
                            doc.importedData.intangibleAssetsOptions,
                        leasing: doc.importedData.leasing
                    };

                    const oldData = doc.investors_programme;

                    oldData.tangibleAssetsOptions.forEach((old, index) => {
                        savedData.tangibleAssetsOptions.forEach(saved => {
                            if (
                                old.name === "Matériel de transport" &&
                                saved.name === "Matériel de transport"
                            ) {
                                if (old.value > saved.value) {
                                    oldData.tangibleAssetsOptions[index].value =
                                        old.value - saved.value;
                                } else {
                                    oldData.tangibleAssetsOptions[
                                        index
                                    ].value = 0;
                                }
                            }
                        });
                    });

                    let oldDataIndex;
                    let currentDataIndex;
                    const currentData = SetInvestorImportedData(rootState);

                    if (
                        utils.isExisted(
                            "Matériel de transport",
                            currentData.tangibleAssetsOptions
                        )
                    ) {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Matériel de transport"
                        );

                        currentDataIndex = currentData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Matériel de transport"
                        );

                        if (oldDataIndex !== -1) {
                            oldData.tangibleAssetsOptions[oldDataIndex].value +=
                                currentData.tangibleAssetsOptions[
                                    currentDataIndex
                                ].value;
                        } else {
                            oldData.tangibleAssetsOptions.push({
                                name: "Matériel de transport",
                                value:
                                    currentData.tangibleAssetsOptions[
                                        currentDataIndex
                                    ].value
                            });
                        }
                    } else {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Matériel de transport"
                        );
                        if (
                            oldDataIndex !== -1 &&
                            oldData.tangibleAssetsOptions[oldDataIndex].value <=
                                0
                        ) {
                            oldData.tangibleAssetsOptions.splice(
                                oldDataIndex,
                                1
                            );
                        }
                    }

                    if (savedData.leasing !== null)
                        oldData.leasing -= savedData.leasing;
                    if (currentData.leasing !== null)
                        oldData.leasing += currentData.leasing;

                    commit("PUT_INVESTMENT", oldData);

                    db.collection("bpis")
                        .doc(`${rootState.user.bpiId}`)
                        .update({
                            investors_programme: oldData,
                            importedData: currentData
                        });
                })
                .catch(error => {
                    console.log(error);
                });
        }
    ),

    saveEditedInvestorsProgrammeCapitalSocial: firestoreAction(
        ({ rootState, commit }) => {
            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .get()
                .then(snapshot => {
                    const doc = snapshot.data();
                    return doc;
                })
                .then(doc => {
                    const savedData = {
                        capitalSocial: doc.importedData.capitalSocial
                    };

                    const oldData = doc.investors_programme;

                    const currentData = SetInvestorImportedData(rootState);

                    if (savedData.capitalSocial !== null)
                        oldData.capitalSocial -= savedData.capitalSocial;
                    if (currentData.capitalSocial !== null)
                        oldData.capitalSocial += currentData.capitalSocial;

                    commit("PUT_INVESTMENT", oldData);

                    db.collection("bpis")
                        .doc(`${rootState.user.bpiId}`)
                        .update({
                            investors_programme: oldData,
                            importedData: currentData
                        });
                });
        }
    ),

    saveEditedInvestorsProgrammetechInstallations: firestoreAction(
        ({ rootState, commit }) => {
            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .get()
                .then(snapshot => {
                    const doc = snapshot.data();
                    return doc;
                })
                .then(doc => {
                    const savedData = {
                        tangibleAssetsOptions:
                            doc.importedData.tangibleAssetsOptions,
                        intangibleAssetsOptions:
                            doc.importedData.intangibleAssetsOptions
                    };

                    const oldData = doc.investors_programme;

                    oldData.tangibleAssetsOptions.forEach((old, index) => {
                        savedData.tangibleAssetsOptions.forEach(saved => {
                            if (
                                old.name === "Installations techniques" &&
                                saved.name === "Installations techniques"
                            ) {
                                if (old.value > saved.value) {
                                    oldData.tangibleAssetsOptions[index].value =
                                        old.value - saved.value;
                                } else {
                                    oldData.tangibleAssetsOptions[
                                        index
                                    ].value = 0;
                                }
                            }
                        });
                    });

                    let oldDataIndex;
                    let currentDataIndex;
                    const currentData = SetInvestorImportedData(rootState);

                    if (
                        utils.isExisted(
                            "Installations techniques",
                            currentData.tangibleAssetsOptions
                        )
                    ) {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Installations techniques"
                        );

                        currentDataIndex = currentData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Installations techniques"
                        );

                        if (oldDataIndex !== -1) {
                            oldData.tangibleAssetsOptions[oldDataIndex].value +=
                                currentData.tangibleAssetsOptions[
                                    currentDataIndex
                                ].value;
                        } else {
                            oldData.tangibleAssetsOptions.push({
                                name: "Installations techniques",
                                value:
                                    currentData.tangibleAssetsOptions[
                                        currentDataIndex
                                    ].value
                            });
                        }
                    } else {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Installations techniques"
                        );
                        if (
                            oldDataIndex !== -1 &&
                            oldData.tangibleAssetsOptions[oldDataIndex].value <=
                                0
                        ) {
                            oldData.tangibleAssetsOptions.splice(
                                oldDataIndex,
                                1
                            );
                        }
                    }

                    commit("PUT_INVESTMENT", oldData);

                    db.collection("bpis")
                        .doc(`${rootState.user.bpiId}`)
                        .update({
                            investors_programme: oldData,
                            importedData: currentData
                        });
                });
        }
    ),

    saveEditedInvestorsProgrammeConstruction: firestoreAction(
        ({ rootState, commit }) => {
            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .get()
                .then(snapshot => {
                    const doc = snapshot.data();
                    return doc;
                })
                .then(doc => {
                    const savedData = {
                        tangibleAssetsOptions:
                            doc.importedData.tangibleAssetsOptions,
                        intangibleAssetsOptions:
                            doc.importedData.intangibleAssetsOptions
                    };

                    const notAllowed = [
                        "Installations techniques",
                        "leasing",
                        "Matériel de transport",
                        "Mobilier de bureau",
                        "Matériel informatique",
                        "Matériel et outillage"
                    ];

                    const oldData = doc.investors_programme;

                    oldData.tangibleAssetsOptions.forEach((old, index) => {
                        savedData.tangibleAssetsOptions.forEach(saved => {
                            if (
                                old.name === saved.name &&
                                notAllowed.indexOf(saved.name) === -1
                            ) {
                                if (old.value > saved.value) {
                                    oldData.tangibleAssetsOptions[index].value =
                                        old.value - saved.value;
                                } else {
                                    oldData.tangibleAssetsOptions[
                                        index
                                    ].value = 0;
                                }
                            }
                        });
                    });

                    let oldDataIndex;
                    let currentDataIndex;
                    const currentData = SetInvestorImportedData(rootState);

                    if (
                        utils.isExisted(
                            "terrain",
                            currentData.tangibleAssetsOptions
                        )
                    ) {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "terrain"
                        );

                        currentDataIndex = currentData.tangibleAssetsOptions.findIndex(
                            item => item.name === "terrain"
                        );

                        if (oldDataIndex !== -1) {
                            oldData.tangibleAssetsOptions[oldDataIndex].value +=
                                currentData.tangibleAssetsOptions[
                                    currentDataIndex
                                ].value;
                        } else {
                            oldData.tangibleAssetsOptions.push({
                                name: "terrain",
                                value:
                                    currentData.tangibleAssetsOptions[
                                        currentDataIndex
                                    ].value
                            });
                        }
                    } else {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "terrain"
                        );
                        if (
                            oldDataIndex !== -1 &&
                            oldData.tangibleAssetsOptions[oldDataIndex].value <=
                                0
                        ) {
                            oldData.tangibleAssetsOptions.splice(
                                oldDataIndex,
                                1
                            );
                        }
                    }

                    if (
                        utils.isExisted(
                            "Construction bâtiment industriel",
                            currentData.tangibleAssetsOptions
                        )
                    ) {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item =>
                                item.name === "Construction bâtiment industriel"
                        );
                        currentDataIndex = currentData.tangibleAssetsOptions.findIndex(
                            item =>
                                item.name === "Construction bâtiment industriel"
                        );
                        if (oldDataIndex !== -1) {
                            oldData.tangibleAssetsOptions[oldDataIndex].value +=
                                currentData.tangibleAssetsOptions[
                                    currentDataIndex
                                ].value;
                        } else {
                            oldData.tangibleAssetsOptions.push({
                                name: "Construction bâtiment industriel",
                                value:
                                    currentData.tangibleAssetsOptions[
                                        currentDataIndex
                                    ].value
                            });
                        }
                    } else {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item =>
                                item.name === "Construction bâtiment industriel"
                        );
                        if (
                            oldDataIndex !== -1 &&
                            oldData.tangibleAssetsOptions[oldDataIndex].value <=
                                0
                        ) {
                            oldData.tangibleAssetsOptions.splice(
                                oldDataIndex,
                                1
                            );
                        }
                    }

                    oldData.intangibleAssetsOptions.forEach((old, index) => {
                        savedData.intangibleAssetsOptions.forEach(saved => {
                            if (old.name === saved.name) {
                                if (old.value > saved.value) {
                                    oldData.intangibleAssetsOptions[
                                        index
                                    ].value = old.value - saved.value;
                                } else {
                                    oldData.intangibleAssetsOptions[
                                        index
                                    ].value = 0;
                                }
                            }
                        });
                    });

                    if (
                        utils.isExisted(
                            "Fonds commercial",
                            currentData.intangibleAssetsOptions
                        )
                    ) {
                        oldDataIndex = oldData.intangibleAssetsOptions.findIndex(
                            item => item.name === "Fonds commercial"
                        );
                        currentDataIndex = currentData.intangibleAssetsOptions.findIndex(
                            item => item.name === "Fonds commercial"
                        );
                        if (oldDataIndex !== -1) {
                            oldData.intangibleAssetsOptions[
                                oldDataIndex
                            ].value +=
                                currentData.intangibleAssetsOptions[
                                    currentDataIndex
                                ].value;
                        } else {
                            oldData.intangibleAssetsOptions.push({
                                name: "Fonds commercial",
                                value:
                                    currentData.intangibleAssetsOptions[
                                        currentDataIndex
                                    ].value
                            });
                        }
                    } else {
                        oldDataIndex = oldData.intangibleAssetsOptions.findIndex(
                            item => item.name === "Fonds commercial"
                        );
                        if (
                            oldDataIndex !== -1 &&
                            oldData.tangibleAssetsOptions[oldDataIndex].value <=
                                0
                        ) {
                            oldData.intangibleAssetsOptions.splice(
                                oldDataIndex,
                                1
                            );
                        }
                    }

                    if (
                        utils.isExisted(
                            "Aménagement et agencement",
                            currentData.tangibleAssetsOptions
                        )
                    ) {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Aménagement et agencement"
                        );
                        currentDataIndex = currentData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Aménagement et agencement"
                        );
                        if (oldDataIndex !== -1) {
                            oldData.tangibleAssetsOptions[oldDataIndex].value +=
                                currentData.tangibleAssetsOptions[
                                    currentDataIndex
                                ].value;
                        } else {
                            oldData.tangibleAssetsOptions.push({
                                name: "Aménagement et agencement",
                                value:
                                    currentData.tangibleAssetsOptions[
                                        currentDataIndex
                                    ].value
                            });
                        }
                    } else {
                        oldDataIndex = oldData.tangibleAssetsOptions.findIndex(
                            item => item.name === "Aménagement et agencement"
                        );
                        if (
                            oldDataIndex !== -1 &&
                            oldData.tangibleAssetsOptions[oldDataIndex].value <=
                                0
                        ) {
                            oldData.tangibleAssetsOptions.splice(
                                oldDataIndex,
                                1
                            );
                        }
                    }

                    commit("PUT_INVESTMENT", oldData);

                    db.collection("bpis")
                        .doc(`${rootState.user.bpiId}`)
                        .update({
                            investors_programme: oldData,
                            importedData: currentData
                        });
                });
        }
    ),

    SaveInvestorsProgramme: firestoreAction(
        ({ state, rootState, rootGetters }) => {
            const investorObject =
                state.programmeDinvestissementPlanDeFinancement;
            let total = 0;
            total += investorObject?.capitalSocial ?? 0;
            total += investorObject?.compteAssocie ?? 0;
            total += investorObject?.augmentationCapital ?? 0;
            total += investorObject?.subventions ?? 0;
            total += investorObject?.leasing ?? 0;
            total += investorObject.creditBancaire.reduce(
                (sum, creditBancaire) => {
                    return (creditBancaire?.montant ?? 0) + sum;
                },
                0
            );

            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .update({
                    investors_programme: {
                        ...state.programmeDinvestissementPlanDeFinancement,
                        capital: total
                    },
                    current_step: rootGetters["user/getLastStep"](
                        "Chiffres d’affaires Prévisionnels"
                    )
                })
                .then(() => {});
        }
    ),

    SaveCaDetails: firestoreAction(({ state, rootState, rootGetters }) => {
        let total = 0;
        if (state.caDetails.type === "CA Détails") {
            total = state.caDetails.offersObject.reduce((a, b) => {
                if (b.date === "Mois")
                    return (
                        a + parseInt(b.price) * parseInt(b.quantiteVente) * 12
                    );
                return a + parseInt(b.price) * parseInt(b.quantiteVente);
            }, 0);
            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .update({
                    chiffres_d_affaires_previsionnels: {
                        details: state.caDetails,
                        total: total,
                        tauxEvolution: state.TauxEvolutionChiffre,
                        tauxRealisation: state.TauxRealisationChiffre
                    },
                    current_step: rootGetters["user/getLastStep"](
                        "Achats Prévisionnels"
                    )
                });
        } else {
            total = state.caDetails.totalCAPrevisionnel;
            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .update({
                    chiffres_d_affaires_previsionnels: {
                        details: state.caDetails,
                        tauxEvolution: state.caDetails.tauxEvolution,
                        tauxRealisation: state.caDetails.tauxRealisation,
                        total: total
                    },
                    current_step: rootGetters["user/getLastStep"](
                        "Achats Prévisionnels"
                    )
                });
        }
    }),

    SaveAchatsPrevisionnel: firestoreAction(
        ({ state, rootState, rootGetters }) => {
            let total = 0;
            if (state.achatsPrevisionnel.type === "details") {
                total = state.achatsPrevisionnel.achats.reduce((a, b) => {
                    if (b.date === "Mois")
                        return (
                            a +
                            parseInt(b.prixAchat) * parseInt(b.quantite) * 12
                        );
                    return a + parseInt(b.prixAchat) * parseInt(b.quantite);
                }, 0);
                db.collection("bpis")
                    .doc(`${rootState.user.bpiId}`)
                    .update({
                        achats_previsionnel: {
                            details: state.achatsPrevisionnel,
                            total: total,
                            tauxEvolution: state.tauxEvolutionAchats
                        },
                        current_step: rootGetters["user/getLastStep"](
                            "Autres charges externes"
                        )
                    });
            } else {
                total = state.achatsPrevisionnel;
                db.collection("bpis")
                    .doc(`${rootState.user.bpiId}`)
                    .update({
                        achats_previsionnel: {
                            details: state.achatsPrevisionnel,
                            total: total.totalPrice,
                            tauxEvolution:
                                state.achatsPrevisionnel.tauxEvolution
                        },
                        current_step: rootGetters["user/getLastStep"](
                            "Autres charges externes"
                        )
                    });
            }
        }
    ),

    SaveAutresCharges: firestoreAction(({ state, rootState, rootGetters }) => {
        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                autres_charges: state.autresCharges,
                current_step: rootGetters["user/getLastStep"](
                    "Charges du personnel"
                )
            })
            .then(() => {});
    }),

    SaveFonctions: firestoreAction(({ state, rootState, rootGetters }) => {
        return db
            .collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                charge_du_personnel: state.fonctions,
                current_step: rootGetters["user/getLastStep"](
                    "Charges du personnel"
                )
            })
            .then(() => "success");
    }),
    SaveChargesPrevisonnel: firestoreAction(
        ({ state, rootState, rootGetters }) => {
            return db
                .collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .update({
                    charge_previsonnel: state.chargePrevisionnel,
                    current_step: rootGetters["user/getLastStep"](
                        "Charges Prévisionnels"
                    )
                })
                .then(() => "success");
        }
    ),

    SaveImportedData: firestoreAction(({ rootState }, importedObject) => {
        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                importedData: importedObject
            });
    }),

    SaveOtherChargeImportedData: firestoreAction(
        ({ rootState }, importedObject) => {
            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .update({
                    OtherChargeImportedData: importedObject
                });
        }
    )
};
